import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { usePmsEquipments, PmsEquipment } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<PmsEquipment> useData={usePmsEquipments} config={config} />;
};

export default List;
